<template>
    <div class="MCourseReportPrview_warp">
        <div class="content_box">
            <pdf v-for="item in pageCount" :key="item" :src="taskInfoData.fullfileurl" :page="item" />
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
import {mapGetters, mapActions} from 'vuex'
import {getCourseTaskInfo} from 'api/api'
import $ from 'jquery'
export default {
    name: 'MCourseReportPrview',
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
        ]
    },
    data() {
        return {
            taskInfoData: {},
            pageCount: ''
        }
    },
    mounted() {
        if (!this.refresh) {
            this.getTaskInfo(this.$route.query.taskid)
            
        }
    },
    activated () {
        if (this.refresh) {
            this.getTaskInfo(this.$route.query.taskid)
            this.setRefresh(false)
        }
    },
    methods: {
        // 回到顶部
        goTop(s, t) {
            $("html,body").animate({
                scrollTop: t
            }, s)
        },
        getTaskInfo(val) {
            this.setLoading(true)
            var params = {
                taskid: val
            }
            getCourseTaskInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.taskInfoData = data.data
                    this.goTop(200, 0)
                    if (data.data.kmctype === 2 && this.taskInfoData.reportimageinfo.length === 0) {
                        this.taskInfoData.fullfileurl = pdf.createLoadingTask(this.taskInfoData.fullfileurl)
                        this.taskInfoData.fullfileurl.then(pdf => {
                            // console.log('pdf.numPages', pdf.numPages)
                            this.pageCount = pdf.numPages
                            this.setLoading(false)
                        })
                    }
                },
                error: data => {
                    this.setLoading(false)
                    // console.log('error：', data)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser',
            'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['loginPop', 'user', 'refresh'])
    },
    components: {
        pdf
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MCourseReportPrview_warp {
        width: 100vw;
        // height: 100vh;
        max-height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        overflow: hidden;
        background-color: rgb(255, 255, 255);
    }
</style>